export default{
    lista:{
        method:'get',
        url:'tabelaprecorublica/lista?id={id}'
    },
    cadastra:{
        method:'post',
        url:'tabelaprecorublica/cadastro'
    },
    delete:{
        method:'delete',
        url:'tabelaprecorublica/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'tabelaprecorublica/editar{/id}'
    },
    update:{
        method:'post',
        url:'tabelaprecorublica/update'
    },
    cola:{
        method:'post',
        url:'tabelaprecorublica/cola'
    },
    pesquisa:{
        method:'get',
        url:'tabelaprecorublica/pesquisa?id={id}&tabela_preco_id={tabela_preco_id}'
    },
    eventocadastro:{
        method:'post',
        url:'tabelapreco/rublica/evento1010/cadastro'
    },
    eventodeleta:{
        method:'delete',
        url:'tabelapreco/rublica/evento1010/deletar{/id}'
    },
    eventoupdate:{
        method:'put',
        url:'tabelapreco/rublica/evento1010/update'
    },
    duplica:{
        method:'get',
        url:'tabela/preco/rublica/duplica{/id}'
    },
    codigo:{
        method:'get',
        url:'tabelaprecorublica/codigo{/id}'
    },
    
}